import { EQUIPMENT_TYPES } from "constants/signup";
import { IRegion, ITrailerType } from "models/Truck";
import { numberFormatter } from "./formatNumber";

export const truckLocation = (
  city: string | null,
  region: IRegion[],
  radius: number,
  type: "origin" | "destination"
) => {
  const cityStr = city ? `${city}, ` : "";
  const regionStr = region
    .map((item) => (type === "origin" ? item.originStates : item.destinationStates))
    .join(", ");
  const location = `${cityStr}${regionStr} ${radius ? "(" + radius + ")" : ""}`;
  return cityStr || regionStr ? location : "Anywhere";
};

export const truckInfo = (trailerTypes: ITrailerType[], length: number, weight: number) =>
  `${
    trailerTypes.length > 0
      ? trailerTypes
          .map(({ loadtypes }) => {
            const loadChoiceFull = EQUIPMENT_TYPES.find((type) => type.value === loadtypes)?.label;
            return loadChoiceFull;
          })
          .join(", ")
      : "Any"
  } / ${length ?? 0} ft / ${numberFormatter(weight) ?? 0} lbs`;
